export default __webpack_public_path__ + "40b081342f7ee03466456303e6e364c7.png";